<template>
   <div class="Homecontainer">
    <my-header></my-header> 
    <!-- 返回顶部 -->
    <div class="backTop hide"  data-menuanchor="page1">
      <a href="#page1" style="width: 100%;height: 100%;display: inline-block;">
       <img src="../assets/img/fanhuidingbu.png">
      </a>
    </div>
    <!-- 内容 -->
    <full-page :options="options" ref="fullpage"  id="fullpage" >
      <!-- 百信科技 -->
      <div class="section section1">
        <div class="box1" >
          <div class="first-floor">
            <img src="../assets/img/banner1.png" alt="">
            <div class="first-content ">
              <p class="p1" >汽车服务工程创新产品提供商</p>
              <p class="p2" >百信科技</p>
              <p class="p3"><span >致力于汽车行业</span></p>
              <p class="p4">服务工程数据加工制作、软件系统定制开发、维修工具设备研发服务</p>
            </div>
          </div>  
          <div class="first-bottom" data-menuanchor="page2">
            <a href="#page2" style="width: 100%;height: 100%;display: inline-block;">
              <img src="../assets/img/icon.png" alt="">
            </a>
          </div>
        </div>
      </div>
      <!-- 企业文化 -->
      <div class="section section2" id="miao"> 
        <div class="box2"> 
          <div class="second-content">
            <p class="title">企业文化</p>
            <div class="OneFirst">
              <div class="OneImg">
                <img src="../assets/img/enterpriseOne.png" alt="">
              </div>
              <div class="OneContent">
                <p class="s1">公司坚持 “质存于心”的企业价值观，始终贯彻“不断创新，为合作伙伴创造价值”的经营理念，打造专业化的服务团队。
                  并以“为振兴民族汽车工业添砖加瓦”为己任，坚持诚信为本，通过持续不断地技术创新、流程创新、服务创新，向合作伙伴提供尽善尽美的产品，
                  最终实现提升民族汽车工业售后技术服务水平的梦想！
                </p> 
              </div>
            </div>
            <div  class="TwoSecond">
              <div class="TwoImg">
                <img src="../assets/img/enterpriseTwo.png" alt="">
              </div>
              <div class="TwoContent">
                <p ><span>企业精神：</span>百折不挠、信以立世</p>
                <p><span>公司宗旨：</span>为员工创造成功、为客户创造价值，实现客户、员工、企业的共同成长</p>
              </div>
            </div>
            <div class="ThreeThird" style="display:flex">
              <div class="ThreeImg">
                <img src="../assets/img/enterpriseThree.png" alt="">
              </div>
              <div class="ThreeContent">
                <p><span>经营理念：</span>创新服务方式、创造服务价值、创立服务品牌</p>
                <p><span>核心价值观：</span>质存于心</p>
              </div>
            </div>
          </div>
          <div class="second-bottom" data-menuanchor="page3">
            <a href="#page3" style="width: 100%;height: 100%;display: inline-block;">
              <img src="../assets/img/icon2.png" alt="">
            </a>
          </div> 
        </div> 
      </div>
      <!-- 产品服务 -->
      <div class="section section3">
        <div class="box3">
          <div class="third-floor">
            <p class="title">产品服务</p>
            <ul>
              <router-link :to="{ path:'product#data'}" tag ="li">
                <div><img src="../assets/img/banner2.png" alt=""></div>
                <p>汽车服务工程数据加工制作</p>
              </router-link>
              <router-link :to="{ path:'product#software'}" tag ="li" id="second">
                <div><img src="../assets/img/banner3.png" alt=""></div>
                <p>软件系统定制开发</p>
              </router-link>
              <router-link :to="{ path:'product#equipment'}" tag ="li" id="third">
                <div><img src="../assets/img/banner4.png" alt="" style="margin-top:40px"></div>
                <p>维修工具设备研发</p>
              </router-link>
            </ul>
          </div>
          <div class="third-bottom" data-menuanchor="page4">
            <a href="#page4" style="width: 100%;height: 100%;display: inline-block;">
              <img src="../assets/img/icon3.png" alt="">
            </a>
          </div>
        </div>
      </div>
      <!-- 合作伙伴 -->
      <div class="section section4">
        <div class="box4">
          <div class="fourth-floor">
            <p class="title">合作伙伴</p>
            <div class="fourth-content">
              <div class="Onecontent" style="displsy:flex">
                <div>
                  <img src="../assets/img/beiqi.png" style=" position: relative;top:30%;left:22%;width:55%">
                </div>
                <div>
                   <img src="../assets/img/futian.png" style="position: relative;top:25%;left:25%;width:50%">
                </div>
                <div>
                  <img src="../assets/img/yutong.png" style="position: relative;top:35%;left:23%;width:55%">
                </div>
                <div>
                  <img src="../assets/img/qirui.png" style="position: relative;top:40%;left:17%;width:65%">
                </div>
                <div>
                  <img src="../assets/img/biyadi.png" style="position: relative;top:32%;left:20%;width:60%">
                </div>
              </div>
              <div class="Twocontent" style="display:flex" >
                <div>
                  <img src="../assets/img/guangqi.png" style="position: relative;top:29%;left:20%;width:60%">
                </div>
                <div>
                  <img src="../assets/img/richan.png" style="position: relative;top:23%;left:22%;width:55%">
                </div>
                <div>
                  <img src="../assets/img/zhongtong.png" style="position: relative;top:27%;left:27%;width:45%">
                </div>
                <div>
                   <img src="../assets/img/changcheng.png" style="position: relative;top:27%;left:20%;width:60%">
                </div>
              </div>
              <div class="Threecontent" style="display:flex">
                <div>
                  <img src="../assets/img/yiqi.png" style="position: relative;top:30%;left:20%;width:60%">
                </div>
                <div>
                  <img src="../assets/img/xiandai.png" style="position: relative;top:33%;left:20%;width:60%">
                </div>
                <div>
                  <img src="../assets/img/haige.png" style="position: relative;top:32%;left:19%;width:60%">
                </div>
                <div>
                  <img src="../assets/img/jianghuai.png" style="position: relative;top:40%;left:18%;width:65%">
                </div>
                <div>
                  <img src="../assets/img/lingpao.png" style="position: relative;top:23%;left:30%;width:40%">
                </div>
              </div>
            </div>
          </div>
          <div class="fourth-bottom" data-menuanchor="page5">
            <a href="#page5" style="width: 100%;height: 100%;display: inline-block;">
              <img src="../assets/img/icon3.png" alt="">
            </a>
          </div>
        </div>
      </div>
      <!-- 联系我们 -->
      <div class="section section5">
        <div class="box5">
          <div class="fifth-floor">
            <p class="title">联系我们</p>
            <div class="fifth-content" >
              <div class="left">
                <p class="address" style="display:flex">地址: <span>河南省郑州市金水区东风路3号财智名座</span></p>
                <p class="phone">电话: 0371-63597329</p>
                <p class="email">邮箱: contact@bisense.cn</p>
              </div>
              <div class="right">
                <img src="../assets/img/bangonglou zhaopian.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <my-footer></my-footer> 
    </full-page>
  </div>
</template>

<script>
  import Vue from 'vue';
  import axios from 'axios';
  import myHeader from '@/components/Header.vue'
  import myFooter from '@/components/Footer.vue'
  import { Carousel} from 'element-ui';
  import FullPage from '@/components/FullPage/FullPage.vue'
  Vue.use(Carousel)
  export default {
    data() {
      return {
        homeNews:{},
        example0:"",
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          afterLoad: this.afterLoad,
          anchors: ['page1', 'page2', 'page3', 'page4','page5'],
          scrollBar: false,
          menu: "#menu",
        }
      }
    },
    mounted() {
    },
    components:{
      myHeader,
      myFooter,
      FullPage
    },
    methods: {
      moreNews(){
        this.$router.push('./news?id=8&page=1')
      },
      goNewsdetail(id){
        this.$router.push(`./newsDetail?id=${id}`)
      },
      enterAnimate(event){
        event.currentTarget.className = "animated  headShake"
      },
      leaveAnimate(event){
        event.currentTarget.className = ""
      }
    },
    watch:{
      // 鼠标滑动时顶部导航加背景，返回顶部按钮显示，
      $route(to, from) {
        if(window.location.href.split("#")[1]=="page1"){
          setTimeout(
            function(){
              $('.backTop').addClass('hide')
            },500)
        }else{
          $('.backTop').removeClass("hide") 
        }
      }
    }
  }
</script>
<style scoped lang = 'scss'>
  @import '@/lib/reset.scss';
  .Homecontainer{
    /* 返回顶部 */
    .backTop{
      position: fixed;
      right:2%;
      bottom:3%;
      z-index:2;
    }
    .backTop img{
      width:50px;
    }
    /* 百信科技动画 */
    .first-content{color: #EEEEEE;opacity: 0;-webkit-transform:scale(0.5, 0.5); transform:scale(0.5, 0.5);transition: all 1s;}
    .active .first-content{opacity: 1; -webkit-transform:scale(1, 1); transform:scale(1, 1); transition-delay: 0.5s;}
    .ltie10 .first-content{opacity: 1; -webkit-transform:scale(1, 1); transform:scale(1, 1); transition-delay: 0.5s;}
    .first-floor img{opacity: 0;transition: all 1s;margin-left:-40%;}
    .active  .first-floor img{margin-left:0;opacity: 1;transition-delay: 0.6s;}
    .ltie10  .first-floor img{margin-left:0;opacity: 1;transition-delay: 0.6s;}
    /*企业文化动画 */
    .second-content{-webkit-transform:scale(0.5, 0.5); transform:scale(0.5, 0.5);opacity: 0;transition: all 1s;}
    .active .second-content{opacity: 1; -webkit-transform:scale(1, 1); transform:scale(1, 1); transition-delay: 0.7s;}
    .ltie10 .second-content{opacity: 1; -webkit-transform:scale(1, 1); transform:scale(1, 1); transition-delay: 0.7s;}
    /*产品服务动画*/
    .third-floor .title{opacity: 0;transition: all 1s;}
    .active .third-floor .title{opacity: 1;transition-delay:0.5s;}
    .ltie10 .third-floor .title{opacity: 1;transition-delay:0.5s;}
    .third-floor ul{opacity:0; text-align: center; transition: all 1s;margin-top:-25%;}
    .active .third-floor ul{margin-top: 0px;opacity:1;transition-delay: 0.8s;}
    .ltie10 .third-floor ul{margin-top: 0px;opacity:1;transition-delay:0.8s;}
    /*合作伙伴动画*/
    .fourth-floor .title{opacity: 0;transition: all 1s;margin-top:-10%;}
    .active .fourth-floor .title{margin-top: 0px;opacity: 1;transition-delay:0.5s;}
    .ltie10 .fourth-floor .title{margin-top: 0px;opacity: 1;transition-delay:0.5s;}
    .fourth-floor .fourth-content{opacity:0;transition: all 1s;margin-top:20%;}
    .active .fourth-floor .fourth-content{margin-top: 0px;opacity:1;transition-delay: 0.6s;}
    .ltie10 .fourth-floor .fourth-content{margin-top: 0px;opacity:1;transition-delay:0.6s;}
    /* 联系我们动画*/
    .fifth-floor .title{-webkit-transform:scale(0.5, 0.5); transform:scale(0.5, 0.5);opacity: 0;transition: all 1s;}
    .active .fifth-floor  .title{opacity: 1; -webkit-transform:scale(1, 1); transform:scale(1, 1); transition-delay: 0.7s;}
    .ltie10 .fifth-floor  .title{opacity: 1; -webkit-transform:scale(1, 1); transform:scale(1, 1); transition-delay: 0.7s;}
    .fifth-floor .fifth-content .left{margin-left: -30%;-webkit-transform:scale(0.5, 0.5); transform:scale(0.5, 0.5);opacity: 0;transition: all 1s;}
    .active .fifth-floor .fifth-content .left{margin-left:10%;opacity: 1; -webkit-transform:scale(1, 1); transform:scale(1, 1); transition-delay: 0.7s;}
    .ltie10 .fifth-floor .fifth-content .left{margin-left:10%;opacity: 1; -webkit-transform:scale(1, 1); transform:scale(1, 1); transition-delay: 0.7s;}
    .fifth-floor .fifth-content .right{margin-top: -40%;-webkit-transform:scale(0.5, 0.5); transform:scale(0.5, 0.5);opacity: 0;transition: all 1s;}
    .active .fifth-floor .fifth-content .right{margin-top:0;opacity: 1; -webkit-transform:scale(1, 1); transform:scale(1, 1); transition-delay: 0.7s;}
    .ltie10 .fifth-floor .fifth-content .right{margin-top:0;opacity: 1; -webkit-transform:scale(1, 1); transform:scale(1, 1); transition-delay: 0.7s;}
    .hide{display: none}
    .contauner-fliud{
      width:100%;
      height: 100%;
    }
    .section{
      position: relative;
    } 
    /* 百信科技 */
    .box1{width: 100%;}
    .section1{
      width: 100%;
      background-image: url('../assets/img/dabeijing1.png');
      background-size:100% 100%;
      }
    .first-floor{
      position: absolute;
      bottom: 0;
      z-index:1; 
    }
    .first-floor img{
      position: relative;
      top:65px;
      width:97%;
    }
    .first-content{
      white-space:nowrap;
      position: absolute;
      top:6%;
      right:-10%;
      text-align: right;
    }
    .first-content .p1{
      font-size: 47px;
      color:#333333;
    }
    .first-content .p2{
      font-size:99.5px;
      color: #575757;
    }
    .first-content .p3 span{
      padding:1% 2%;
      background:#154899;
      font-size:47px;
      color: #fff;
    }
    .first-content .p4{
      font-size:25px;
      color: #575757;
      line-height: 50px;
    }
    /*所以页的底部箭头 */
    .first-bottom,.second-bottom,.third-bottom,.fourth-bottom{
      position:absolute;
      bottom:3%;
      left: 49%;   
      z-index:2;
      text-align: center;
      display: table-cell; 
      vertical-align: middle ;
    }
    .first-bottom p{
      color: #fff;
    }
    .first-bottom img,.second-bottom img,.third-bottom img,.fourth-bottom img{
      margin-top:8px;
      width:80% ;
      animation: bounce-down 1s linear infinite;
    }
    @keyframes bounce-down{
      25% {transform:translateY(-4px);}
      50% {transition: translateY(0);}
      75% {transform: translateY(4px);}
      100% {transform:translateY(0);}
    }
    /* 企业文化 */
    .section2{
      width: 100%;
      background-image: url('../assets/img/dabeijing2.png');
      background-size:100% 100%;
    }
    .second-content{
      position: absolute;
      top:8.5%;
      z-index:1;
      margin: 0 15.5%;
    }
    .second-content .title{
      font-size: 25px;
      margin:1% 0 2% 0;
    }
    .OneFirst,.TwoSecond,.ThreeThird{
      display: flex;
      margin:0 0 1.5%  2%;
    }
    .OneFirst .OneImg,.TwoSecond .TwoImg,.ThreeThird .ThreeImg{
      width:27%;
      overflow: hidden;
    } 
    .OneFirst .OneImg img,.TwoSecond .TwoImg img,.ThreeThird .ThreeImg img{
      width:100%;
    }
    .OneFirst .OneContent{
      width:65%;
      margin-top:1%;
      margin-left:7%;
    }
    .TwoSecond .TwoContent,.ThreeThird .ThreeContent{
      width:65%;
      margin-top:6%;
      margin-left:7%;
    }
    .second-content .s1{ 
      margin-top:3%;
      text-indent:2em;
      margin-bottom:3%;
    }
    .second-content p{
      font-size: 20px;
      color: #555555;
      line-height:35px;
    }
    .second-content p span{
      font-size:25px;
      color: #555555;
    }
    /* 产品服务 */
    .section3{
      width: 100%;
      background-image: url('../assets/img/dabeijing3.png');
      background-size:100% 100%;
    }
    .third-floor{
      width:100%;
      text-align: center;
      position: absolute;
      top:18%;
      z-index:1;
    }
    .third-floor ul{
      list-style: none;
      display: flex;
      text-align: center;
      justify-content: center;
      width:100%;
    } 
    .third-floor ul li{
      text-align: center;
      margin:4% 3% 3%;
      padding:3% 0%;
      position: relative;
      box-shadow: border-box;
      border:1px solid transparent;
       transition:0.2s linear;
    }
    .third-floor ul li:hover{
      cursor:pointer;
      /* border:1px solid; */
      transform: scale(1.1) translateY(-50px);
      /* background: rgba(0,0,0,0.2); */
      /* position: relative;
      z-index: 5 */
    }
    .third-floor ul li:hover p{
      color: #003e8d;
    }
    .third-floor ul li div{
      width: 100%;
      height:240px;
      overflow: hidden;
    }
    .third-floor ul li:hover{box-sizing: border-box;}
    .third-floor ul li div img{
      width:80%;
      margin-top:3%;
      transition: 1s linear;
      position: relative;
      z-index: 1
    }
    .third-floor ul li div img:hover{
      /* transform: scale(1.1);
      opacity: 0.8;  */
    } 
    .third-floor ul li p{
      white-space: nowrap;
      font-size: 25px;
      color:#555555;
      line-height: 50px;
    }
     .third-floor .title::before,.fourth-floor .title::before{
      content: "——"
    }
    .third-floor .title,.fourth-floor .title{
      font-size: 65px;
      color:#004098;
      text-align: center;
      margin-bottom: 2%;
    }
    .third-floor .title::after,.fourth-floor .title::after{
      content: "——"
    }
    /* 合作伙伴 */
    .section4{
      width: 100%;
      background-image: url('../assets/img/dabeijing4.png');
      background-size:100% 100%;
    }
    .fourth-floor{
      position: absolute;
      top:16%;
      z-index:1;
      margin:0 15%;
    }
    .fourth-content{
      width:1281px;
      height: 520px;
      background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
      background-size:100% 100%;
      padding: 4% 0;
    }
    .Onecontent,.Twocontent,.Threecontent{
      display: flex;
      justify-content: center;
    }
    .Twocontent,.Threecontent{
      margin-top: -7%;
    }
    .Onecontent div,.Twocontent div,.Threecontent div{
      width:16%;
      height:200px;
      background: url('../assets/img/logobaisebeijing.png') no-repeat;
      background-size: 100% 100%;
      transition: 0.5s linear;
      margin:0 0.5%;
    }
    .Onecontent img,.Twocontent img,.Threecontent img{
      transition:0.5s linear
    }
    .Onecontent div:hover,.Twocontent div:hover,.Threecontent div:hover{
      cursor: pointer;
      animation: identifier 1s;
      transform: scale(1.06);
    }
    @keyframes identifier {
      0%{transform: rotate(0deg) scale(1.06)};
      50%{transform: rotate(-10deg) scale(1.06)}
      100%{transform: rotate(10deg) scale(1.06)}
    }
    /* 联系我们 */
    .section5{
      width: 100%;
      background-image: url('../assets/img/dabeijing5.png');
      background-size:100% 100%;
    }
    .fifth-floor{
      position: absolute;
      z-index: 1;
      top:20%;
    }
    .fifth-floor .title {
      font-size:35px;
      color: #fff;
      padding: 44px 115px;
      margin:0% 13%;
      background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
      background-size: 303px 134px;
    }
    .fifth-content{
      display: flex;
      font-size: 25px;
      color: #555555;
      margin:1% 3%;
    }
    .fifth-content .address::before{
      content:url(../assets/img/dizhitubiao.png);
      margin-right: 2%;
      vertical-align: middle;
    }
    .fifth-content .phone::before{
      content: url(../assets/img/dinahuatubiao.png);
      margin-right: 1%;
      vertical-align: middle;
    }
    .fifth-content .email::before{
      content: url(../assets/img/e-mail.png);
      margin-right: 1%;
      vertical-align: middle;
    }
    .fifth-content .left {
      white-space:nowrap;
      line-height: 10px;
      margin:11% 0 0 0%;
    }
    .fifth-content .left p{
      line-height: 40px;
    }
    .fifth-content .right {
      position: relative;
      margin: 0 3%
    }
    @media screen and (max-width:1680px) and (min-width:1440px){
      /* 第一层 */
      .first-floor>img{
        position: relative;
        top:55px;
        width:75%;
      }
      .first-content{
        white-space:nowrap;
        position: absolute;
        top:-5%;
        right:7%;
        text-align: right;
      }
      .first-content .p4{
        font-size:24px;
      }
      .first-bottom img,.second-bottom img,.third-bottom img,.fourth-bottom img{
        margin-top:4px;
        width:80% ;
      }
      /* 企业文化 */
      .second-content{
        position: absolute;
        top:8.5%;
        z-index:1;
        margin: 0 15.5%;
      }
      .second-content p{
        font-size: 18px;
        line-height:28px;
      }
      .OneFirst .OneImg,.TwoSecond .TwoImg,.ThreeThird .ThreeImg{
        width:25.5%;
        overflow: hidden;
      } 
      .OneFirst .OneContent{
        margin-top:0%;
        margin-left:7%;
      }
      .TwoSecond .TwoContent,.ThreeThird .ThreeContent{
        margin-top:6%;
        margin-left:7%;
      }
      .second-content p span{
        font-size:22px;
        color: #555555;
      }
      /* 产品服务 */
      .third-floor ul li{
        text-align: center;
        margin:4% 2% 3%;
      }
      /* 合作伙伴 */
      .fourth-floor{
        position: absolute;
        top:20%;
        z-index:1;
        margin:0 23%;
      }
      .fourth-content{
        width:940px;
        height:400px;
        background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
        background-size:100% 100%;
      }
      .Onecontent div,.Twocontent div,.Threecontent div{
        height:150px;
      }
      /* 联系我们 */
      .fifth-floor .title {
        font-size:35px;
        color: #fff;
        padding: 42px 110px;
        margin:0% 180px;
        background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
        background-size: 300px 134px;
      }
      .fifth-content{
        font-size: 23px;
        margin:1% -5%; 
      }
      .fifth-floor .fifth-content .left {
        white-space: pre-wrap;
        margin:6% 0 0 0%;
      }
      .fifth-content .left p{
        line-height:28px;
      }
      .fifth-content .right {
        margin: 0 2%
      }
      .fifth-content .right img{
        width: 90%; 
      }
      .active .fifth-floor .fifth-content .left{margin-left:16%;}
      .ltie10 .fifth-floor .fifth-content .left{margin-left:16%;}
    }
    @media screen and (max-width:1440px) and (min-width:1366px){
      /* 返回顶部 */
      .backTop{
        position: fixed;
        top:93%;
        right:2%;
        z-index:2;
      }
      .backTop img{
        width:45px;
      }
      /* 第一层 */
      .first-floor>img{
        width:75%; 
        top:40px;
      }
      .first-content{
        white-space:nowrap;
        position: absolute;
        top:-7%;
        right:9%;
        text-align: right;
      }
      .first-content .p1{
        font-size: 41px;
      }
      .first-content .p2{
        font-size:83px;
      }
      .first-content .p3 span{
        font-size:43px;
      }
      .first-content .p4{
        font-size:21px;
      }
      .first-bottom img,.second-bottom img,.third-bottom img,.fourth-bottom img{
        margin-top:4px;
        width:70% ;
      }
      /* 企业文化 */
       .second-content{
        position: absolute;
        top:8.5%;
        z-index:1;
        margin: 0 15.5%;
      }
      .second-content .title{
        margin:2% 0 5% 0;
      }
      .second-content p{
        font-size: 17px;
        line-height:25px;
      }
      .OneFirst .OneImg,.TwoSecond .TwoImg,.ThreeThird .ThreeImg{
        width:26%;
        overflow: hidden;
      } 
      .OneFirst .OneContent{
        margin-top:1%;
        margin-left:7%;
      }
      .TwoSecond .TwoContent,.ThreeThird .ThreeContent{
        margin-top:6.4%;
        margin-left:7%;
      }
      .second-content p span{
        font-size:19px;
        color: #555555;
      }
      .third-floor .title,.fourth-floor .title{
        font-size:55px;
      }
      /* 产品服务 */
      .third-floor ul li div{
        width: 100%;
        height: 220px;
        margin-bottom:2%;
      }
      .third-floor ul li{
        text-align: center;
        margin:3% 0 0%;
      }
      .third-floor ul li p{
       font-size: 21px;
      }
      .third-floor ul li div img{
        width: 75%;
      }
      /* 合作伙伴 */
      .fourth-floor{
        position: absolute;
        top:20%;
        z-index:1;
        margin:0 20%;
      }
      .fourth-content{
        width:900px;
        height:370px;
        background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
        background-size:100% 100%;
      }
      .Onecontent div,.Twocontent div,.Threecontent div{
        height:145px;
      }
      /* 联系我们 */
      .fifth-floor .title {
        font-size:30px;
        color: #fff;
        padding: 40px 85px;
        margin:0% 170px;
        background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
        background-size: 240px 120px;
      }
      .fifth-content{
        font-size: 22px;
        color: #555555;
        margin:1% -2%; 
      }
      .fifth-floor .fifth-content .left {
        white-space: pre-wrap;
        margin:7.5% 0 0 0%;
      }
      .fifth-content .left p{
        line-height:25px;
      }
      .fifth-content .right img{
        width:93%;
      }
      .active .fifth-floor .fifth-content .left{margin-left:14%;}
      .ltie10 .fifth-floor .fifth-content .left{margin-left:14%;}
    }
    @media screen and (max-width:1366px) and (min-width:1280px){
      /* 返回顶部 */
      .backTop{
        position:fixed;
        top:92%;
        right:2%;
        z-index:2;
      }
      .backTop img{
        width:40px;
      }
      /* 第一层 */
      .first-floor>img{
        top:40px;
        width:70%;
      }
      .first-content{
        white-space:nowrap;
        position: absolute;
        top:0%;
        right:11%;
        text-align: right;
      }
      .first-content .p1{
        font-size: 30px;
        line-height: 40px;
      }
      .first-content .p2{
        font-size:70px;
      }
      .first-content .p3 span{
        font-size:35px;
      }
      .first-content .p4{
        font-size:20px;
      }
      .first-bottom img,.second-bottom img,.third-bottom img,.fourth-bottom img{
        margin-top:4px;
        width:70% ;
      }
      /* 企业文化 */
       .second-content{
        position: absolute;
        top:8.5%;
        z-index:1;
        margin: 0 15.5%;
      }
      .second-content .title{
        margin:1.5% 0 2% 0;
      }
      .second-content p{
        font-size: 15px;
        line-height:20px;
      }
      .OneFirst .OneImg,.TwoSecond .TwoImg,.ThreeThird .ThreeImg{
        width:25%;
        overflow: hidden;
      } 
      .OneFirst .OneContent{
        margin-top:1.6%;
        margin-left:7%;
      }
      .TwoSecond .TwoContent,.ThreeThird .ThreeContent{
        margin-top:6.4%;
        margin-left:7%;
      }
      .second-content p span{
        font-size:16px;
        color: #555555;
      }
      .third-floor .title,.fourth-floor .title{
        font-size: 52px;
      }
      /* 产品服务 */
      .third-floor ul li div{
        width: 100%;
        height: 210px;
      }
      .third-floor ul li{
        text-align: center;
        margin:0% 0 0%;
      }
      .third-floor ul li:hover{
        cursor:pointer;
        transform: scale(1.05) translateY(-30px);
      }
      .third-floor ul li p{
        font-size: 21px;
      }
      .third-floor ul li div img{
        width:70%;
      }
      /* 合作伙伴 */
      .fourth-floor{
        position: absolute;
        top:15%;
        z-index:1;
        margin:0 22%;
      }
      .fourth-content{
        width:800px;
        height:300px;
        background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
        background-size:100% 100%;
        padding:3% 0;
      }
      .Onecontent div,.Twocontent div,.Threecontent div{
        height:122px;
      }
      /* 联系我们 */
      .fifth-floor .title {
        font-size:26px;
        color: #fff;
        padding: 30px 70px;
        margin:0% 150px;
        background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
        background-size:200px 95px;
      }
      .fifth-content{
        font-size:19px;
        margin:0% 0%;
      }
      .fifth-floor .fifth-content .left {
        white-space: pre-wrap;
        margin:8% 0 0 0%;
      }
      .fifth-content .right img{
        width:87%;
      }
      .fifth-content .left p{
        line-height:22px;
      }
      .active .fifth-floor .fifth-content .left{margin-left:12%;}
      .ltie10 .fifth-floor .fifth-content .left{margin-left:12%;}
    }
    @media screen and (max-width:1280px) and (min-width:1024px){
      /* 返回顶部 */
      .backTop{
        position:fixed;
        top:92%;
        right:2%;
        z-index:2;
      }
      .backTop img{
        width:40px;
      }
      /* 第一层 */
      .first-floor>img{
        top:35px;
        width:70%;
      }
      .first-content{
        white-space:nowrap;
        position: absolute;
        top:-5%;
        right:11%;
        text-align: right;
      }
      .first-content .p1{
        font-size: 30px;
      }
      .first-content .p2{
        font-size:68px;
      }
      .first-content .p3 span{
        font-size:33px;
      }
      .first-content .p4{
        font-size:19px;
      }
      .first-bottom img,.second-bottom img,.third-bottom img,.fourth-bottom img{
        margin-top:5px;
        width:50% ;
      }
      /* 企业文化 */
      .second-content{
        position: absolute;
        top:8.5%;
        z-index:1;
        margin: 0 15.5%;
      }
      .second-content .title{
        /* margin:1.5% 0 2% 0; */
      }
      .second-content p{
        font-size: 15px;
        line-height:22px;
      }
      .OneFirst .OneImg,.TwoSecond .TwoImg,.ThreeThird .ThreeImg{
        width:24%;
        overflow: hidden;
      } 
      .OneFirst .OneContent{
        margin-top:0.5%;
        margin-left:7%;
      }
      .TwoSecond .TwoContent,.ThreeThird .ThreeContent{
        margin-top:5%;
        margin-left:7%;
      }
      .second-content p span{
        font-size: 16px;
        color: #555555;
      }
      .third-floor .title,.fourth-floor .title{
        font-size: 50px;
      }
      /* 产品服务 */
      .third-floor ul li div{
        width: 100%;
        height: 200px;
      }
      .third-floor ul li{
        text-align: center;
        margin:0% 0 0%;
      }
      .third-floor ul li p{
        font-size: 21px;
      }
      .third-floor ul li div img{
        width:65%;
      }
      /* 合作伙伴 */
      .fourth-floor{
        position: absolute;
        top:15%;
        z-index:1;
        margin:0 22%;
      }
      .fourth-content{
        width:800px;
        height:300px;
        background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
        background-size:100% 100%;
        padding:2% 0;
      }
      .Onecontent div,.Twocontent div,.Threecontent div{
        height:125px;
      }
      /* 联系我们 */
      .fifth-floor .title {
        font-size:26px;
        color: #fff;
        padding: 30px 70px;
        margin:0% 150px;
        background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
        background-size:200px 95px;
      }
      .fifth-content{
        font-size:19px;
        margin:0% 0%;
      }
      .fifth-floor .fifth-content .left {
        white-space: pre-wrap;
        margin:7% 0 0 0%;
      }
      .fifth-content .right img{
        width:85%;
      }
      .fifth-content .left p{
        line-height:22px;
      }
      .active .fifth-floor .fifth-content .left{margin-left:12%;}
      .ltie10 .fifth-floor .fifth-content .left{margin-left:12%;}
    }
    @media screen and (max-width:1024px)and (min-width:650px){
      /* 第一层 */
      .first-floor>img{
        top:35px;
        width:80%;
      }
      .first-content{
        white-space:nowrap;
        position: absolute;
        top:-8%;
        right:8%;
        text-align: right;
      }
      .first-content .p1{
        font-size: 28px;
      }
      .first-content .p2{
        font-size:60px;
      }
      .first-content .p3 span{
        font-size:28px;
      }
      .first-content .p4{
        font-size:16px;
      }
      .first-bottom img,.second-bottom img,.third-bottom img,.fourth-bottom img{
        margin-top:4px;
        width:45% ;
      }
      .third-floor .title,.fourth-floor .title{
        font-size:40px;
      }
      /* 企业文化 */
      .second-content{
        position: absolute;
        top:8.5%;
        z-index:1;
        margin: 0 15.5%;
      }
      .second-content .title{
        margin:4% 0 3% 0;
      }
      .second-content p{
        font-size: 15px;
        line-height:22px;
      }
      .OneFirst .OneImg,.TwoSecond .TwoImg,.ThreeThird .ThreeImg{
        width:30%;
        overflow: hidden;
      } 
      .OneFirst .OneContent{
        margin-top:0%;
        margin-left:6%;
      }
      .TwoSecond .TwoContent{
        margin-top:5.2%;
        margin-left:7%;
      }
      .ThreeThird .ThreeContent{
        margin-top:6%;
        margin-left:7%;
      }
      .second-content p span{
        font-size: 16px;
        color: #555555;
      }
      /* 产品服务 */
      .third-floor ul li div{
        width: 100%;
        height: 190px;
      }
      .third-floor ul li{
        text-align: center;
        margin:4% 0 0%;
      }
      .third-floor ul li p{
        font-size: 21px;
      }
      .third-floor ul li div img{
        width:65%;
      }
      /* 合作伙伴 */
      .fourth-floor{
        position: absolute;
        top:15%;
        z-index:1;
        margin:0 10%;
      }
      .fourth-content{
        width:800px;
        height:300px;
        background: url(../assets/img/toumingbaisexiaobeijing.png) no-repeat center ;
        background-size:100% 100%;
      }
      .Onecontent div,.Twocontent div,.Threecontent div{
        height:120px;
      }
      /* 联系我们 */
      .fifth-floor .title {
        font-size:26px;
        color: #fff;
        padding: 30px 70px;
        margin:0% 150px;
        background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
        background-size:200px 95px;
      }
      .fifth-content{
        font-size:18px;
        margin:2% 0%;
      }
      .fifth-floor .fifth-content .left {
        white-space: pre-wrap;
        margin:7% 0 0 0%;
      }
      .fifth-content .right img{
        width:92%;
      }
      .fifth-content .left p{
        line-height:22px;
      }
    
      .active .fifth-floor .fifth-content .left{margin-left:16%;}
      .ltie10 .fifth-floor .fifth-content .left{margin-left:16%;}
    } 
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue